import inViewport from './inViewport';

/**
 * Init bootstrap 5 carousel with dynamic import
 *
 * @param carousels_items
 */
export function carouselInit(carousels_items = '.carousel') {
	const carousels = carousels_items instanceof HTMLElement ? carousels_items : document.querySelectorAll(carousels_items);
	
	if (carousels.length) {
		import('bootstrap')
			.then(({Carousel}) => {
				for (const carousel of carousels) {
					let interval = parseInt(carousel.dataset.bsRide);

					if (interval === undefined || isNaN(interval)) {
						interval = 5000;
					}

					const inited_carousel = new Carousel(carousel, {
						interval: interval
					});
					inViewport(carousel, ({entry, target_el}) => {
						inited_carousel.cycle();
					}, {});
				}
			});
	}
}

export function carouselHideFirstAndLastArrow() {
	document.addEventListener('slide.bs.carousel', e => {
		const target_slide = e.relatedTarget, slide_index = parseInt(target_slide.dataset.index);

		let prev_button = document.querySelector(`#${e.target.id} .carousel-control-prev`);

		prev_button && prev_button.classList.remove('hide');
	}, {
		once: true
	});
}
